import axios from 'axios'
import * as Types from '../types'

export default
{
	state:
	{
		order: null,
	},

	getters:
	{
		hasOrder: state => state && state.order && !!state.order.id,
	},

	mutations:
	{
		[Types.ORDER_CLEAR](state)
		{
			state.order = null
		},

		[Types.ORDER_DETAILS](state, order)
		{
			state.order = order
		},
	},

	actions:
	{
		[Types.ORDER_CLEAR]({ commit })
		{
			commit(Types.ORDER_CLEAR)
		},

		[Types.ORDER_DETAILS]({ commit }, { orderId })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/orders/' + orderId)
						.then
						(
							response =>
							{
								commit(Types.ORDER_DETAILS, response.data.data)
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.ORDER_SITE_NAME]({ dispatch }, { orderId, address, label })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.post('/api/orders/' + orderId + '/rename', { address, label })
						.then
						(
							async response =>
							{
								await dispatch(Types.ORDER_DETAILS, { orderId })
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},
	},
}